import { executiveKpis } from './dashboard.data';
import { ExecutiveKpiCard } from './ExecutiveKpiCard';

export const ExecutiveMetricGrid = () => (
  <section aria-labelledby="arx-dashboard-kpis-title">
    <div className="arx-executive-section-heading">
      <div>
        <span>VISÃO CONSOLIDADA</span>
        <h2 id="arx-dashboard-kpis-title">Indicadores executivos</h2>
      </div>
      <p>Leitura inicial da operação corporativa e da evolução da plataforma.</p>
    </div>

    <div className="arx-executive-kpi-grid">
      {executiveKpis.map(item => (
        <ExecutiveKpiCard item={item} key={item.id} />
      ))}
    </div>
  </section>
);
